import script from "./ReceiptsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptsPage.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptsPage.vue?vue&type=style&index=0&id=281f2546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281f2546"]])

export default __exports__